/*
 * guide-tabs.js — click-to-switch for the MAC / WINDOWS (and similar) tab
 * containers embedded in keyboard guide page content.
 *
 * Markup (authored in the page body):
 *   <div class="tab-container">
 *     <div class="tab-buttons">
 *       <button data-tab="fn-mac" class="tab-btn active">MAC</button>
 *       <button data-tab="fn-win" class="tab-btn">WINDOWS</button>
 *     </div>
 *     <div id="fn-mac" class="tab-panel active">…</div>
 *     <div id="fn-win" class="tab-panel">…</div>
 *   </div>
 *
 * Event-delegated, so it covers every .tab-container on the page with no
 * per-container wiring.
 */
(function () {
  function activate(btn) {
    var container = btn.closest('.tab-container');
    if (!container) return;
    var targetId = btn.getAttribute('data-tab');

    container.querySelectorAll('.tab-btn').forEach(function (b) {
      b.classList.toggle('active', b === btn);
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });
    container.querySelectorAll('.tab-panel').forEach(function (panel) {
      panel.classList.toggle('active', panel.id === targetId);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.tab-container .tab-btn');
    if (btn) activate(btn);
  });

  // Make the buttons real tabs for AT / keyboard users.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.tab-container').forEach(function (container) {
      var buttons = container.querySelectorAll('.tab-btn');
      var list = container.querySelector('.tab-buttons');
      if (list) list.setAttribute('role', 'tablist');
      buttons.forEach(function (b) {
        b.setAttribute('role', 'tab');
        b.setAttribute('type', 'button');
        b.setAttribute('aria-selected', b.classList.contains('active') ? 'true' : 'false');
      });
    });
  });
})();
